import {
  SETENGLISHPOSITIVERESPONSE,
  SETENGLISHNEGATIVERESPONSE,
  SETSPANISHPOSITIVERESPONSE,
  SETSPANISHNEGATIVERESPONSE,
} from './actionType'

// initialState shows what we are going to change
const initialState = {
  // empty text field
  inputEnglishPositiveResponse: '',
  inputEnglishNegativeResponse: '',
  inputSpanishPositiveResponse: '',
  inputSpanishNegativeResponse: '',
  // empty data field
  // data: null,
}

// Checks the type of the action and returns the appropriate state
export default function responseCreateReducer(state = initialState, action) {
  switch (action.type) {
    case SETENGLISHPOSITIVERESPONSE:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputEnglishPositiveResponse: action.data,
      })
    case SETENGLISHNEGATIVERESPONSE:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputEnglishNegativeResponse: action.data,
      })
    case SETSPANISHPOSITIVERESPONSE:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputSpanishPositiveResponse: action.data,
      })
    case SETSPANISHNEGATIVERESPONSE:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputSpanishNegativeResponse: action.data,
      })
    default:
      // returns state as is without changes
      return state
  }
}
